import { render, staticRenderFns } from "./ConfirmAccountPassword.vue?vue&type=template&id=4f272c73&"
import script from "./ConfirmAccountPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccountPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports